"use client";

import { Notification } from "@/types/notification";
import NotificationItem, {
  NotificationAvatar,
  NotificationWorkspaceLink,
} from "@/components/tailwind/notification/notificationItem";
import { useWorkspaceContext } from "@/contexts/workspaceContext";

interface NotificationWorkspaceInviteProps {
  notification: Notification;
}

export default function NotificationWorkspaceInvite({ notification }: NotificationWorkspaceInviteProps) {
  const { getMemberName } = useWorkspaceContext();
  const displayName = getMemberName(notification.createdBy?.userId) || getMemberName(notification.createdBy?.userEmail) || notification.createdBy?.userName || "An admin";

  return (
    <NotificationItem
      icon={<NotificationAvatar name={displayName} userId={notification.createdBy?.userId} email={notification.createdBy?.userEmail} />}
      createdAt={notification.createdAt}
      unread={!notification.read}
      title={displayName}
      message={
        <>
          Added you to the workspace{" "}
          <NotificationWorkspaceLink
            workspaceId={notification.workspaceId}
            workspaceName={notification.workspaceName}
          />
        </>
      }
    />
  );
}
